/* eslint react/display-name: "off" */
/* eslint react/prop-types: "off" */
import React from "react";

import * as V from "yup";

import { mapFiltersFor, mapFormFieldsFor } from "srx-shared";
import { Cell, Header } from "srx-shared/mui";

import { Actions } from "@comp/TypesManagementPages/Actions";
import { BinType } from "@items/types";

export const BinTypeItem = {
  type: BinType,
  name: "BinType",
  title: "Bin Type"
};

// table
BinTypeItem.columns = [
  {
    Header: "Bin Type Number",
    accessor: "id",
    Cell: props => <Cell {...props} />
  },
  {
    Header: "Type Name",
    accessor: "name",
    Cell: props => <Cell {...props} />
  },
  {
    Header: <Header center>{"Actions"}</Header>,
    maxWidth: 100,
    resizable: false,
    sortable: false,
    Cell: ({ row }) => <Actions row={row._original} item={BinTypeItem} />
  }
];

// filters
BinTypeItem.filtersConfig = {
  name: {
    name: "Type Name"
  }
};
BinTypeItem.filters = mapFiltersFor(BinTypeItem, ["name"]);

// form fields
BinTypeItem.fieldsConfig = {
  name: {
    label: "Type Name",
    initialValue: "",
    required: true,
    size: 12
  }
};

BinTypeItem.schema = V.object({
  name: V.string().label("Type Name").required().max(255).nullable()
});

BinTypeItem.createForm = mapFormFieldsFor(BinTypeItem, ["name"]);

BinTypeItem.editForm = mapFormFieldsFor(BinTypeItem, ["name"]);

BinTypeItem.modalEditForm = true;
